module.exports = __webpack_public_path__ + "img/ChevronUp-Brn.0cb46519.png";